/** CT Product Projection variant scopes used by shop-criteria where builders. */
export const VARIANT_SCOPES = ['masterVariant', 'variants'] as const;
